<template>
    <button type="button" @click="clickefect" :class="type" :style="buttonStyle">{{ text }}</button>
</template>
<script>
export default {
  name: 'CustomButton',
  props: {
    type: String,
    text: String,
    bgColor: String,
    originalWidth: Number,
    originalHeight: Number,
    toUrl: String,
    positionY: String
  },
  methods: {
    clickefect (event) {
      let _this = event.target
      const circle = document.createElement('div')
      const x = event.layerX
      const y = event.layerY
      circle.classList.add('circle-click')
      circle.style.left = `${x}px`
      circle.style.top = `${y}px`
      _this.appendChild(circle)
      if (this.toUrl.indexOf('http') !== -1) {
        window.open(this.toUrl, '_blank')
      } else {
        if (!this.$parent.$parent.$parent.isMobile) {
          $('#container').animate({scrollLeft: this.$parent.$parent.$parent.indice[this.toUrl]}, 1000)
        } else {
          location.hash = '#' + this.toUrl
          setTimeout(function() {
          let obj = $('#category-' + this.toUrl).find('img')[0]
          $(obj).attr('src', $(obj).attr('data-url'))
          }, 1000)
        }
      }
    }
  },
  data () {
    return {
      textButton: '',
      textColor: '',
      finalBgColor: '',
      preBottom: '55'
    }
  },
  computed: {
    buttonStyle () {
      let btnStyle = {}
      let pageHeight = this.$parent.$parent.$parent.pageHeight
      let extraCut = !this.$parent.$parent.$parent.isMobile ? this.$parent.$parent.$parent.desktopScrollBarX : 0
      if (this.type === 'menu-button') {
        btnStyle.backgroundColor = this.bgColor
        btnStyle.marginBottom = ((pageHeight * this.$parent.$parent.$parent.menuData.margin_bottom) / this.$parent.$parent.$parent.menuData.originalHeight) + 'px'
      } else {
        btnStyle.left = ((this.$parent.$parent.$parent.pageWidth * 0.20) * 0.5) + 'px'
        btnStyle.maxWidth = this.$parent.$parent.$parent.pageWidth * 0.80 + 'px'
        console.log("width setted",this.$parent.$parent.$parent.pageWidth * 0.80)
        btnStyle.bottom = (((pageHeight * parseInt(this.preBottom)) / this.$parent.$parent.$parent.menuData.originalHeight) + extraCut) + 'px'
        if(this.text.length > 20 && this.text.length < 27){
          btnStyle.fontSize = '0.850em'
        }else if(this.text.length >= 27 && this.text.length < 30){
          btnStyle.fontSize = '0.750em'
        }else if(this.text.length >= 30){
          btnStyle.fontSize = '0.650em'
        }
      }
      return btnStyle
    }
  },
  mounted () {

  }
}
</script>
  <style scoped>
   .menu-button,.cenbtn-txt-web{
    border:none;
    border-radius:10px;
    font-family:'Montserrat';
    font-weight:bold;
    font-size:1em;
    width:75%;
    height:auto;
    text-align:center;
    padding:10px 20px;
    cursor:pointer;
    position: relative;
    z-index:1;
    overflow: hidden;
   }
   .menu-button{
     color:#fff;
     font-size:1.250em;
     width:75%;
     height:auto!important;
     padding:1.5vh 1rem;
   }
   .cenbtn-txt-web{
     color: #473D38!important;
     background-color:#F9BB10!important;
     padding: 14px 20px;
     font-size: 1em;
     width: 80%;
   }
    .menu-button:hover,.cenbtn-txt-web:hover {
    transform: scale(1.01);
    box-shadow: 0 1px 3px darkgray;
    }

  </style>



// WEBPACK FOOTER //
// src/components/CustomButtonComponent.vue